export enum TakeLeaveSortType {
  Id,
  ApproverFullName,
  CreationDateTime,
  EmployeeFullName,
  FromDateTime,
  TakeLeaveType,
  IsAccepted,
  ToDateTime,
  Description,
  IsDeleted
}